export default "/images/video_thumb.png?17ff1784a28b54bf06f0b9a83aab72e2";